module.exports = __webpack_public_path__ + "static/img/yamamoto_05.dfa6f9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_05.jpg
// module id = 3aVN
// module chunks = 0